import { Map } from 'immutable';

import { CURRENCIES__FETCH, USER__LOG_OFF } from '../constants';
import { mergeArray } from '../../util';

const defaultState = new Map();

export default function (state = defaultState, action) {
  switch (action.type) {
    case CURRENCIES__FETCH:
      return mergeArray(state, action.data);
    case USER__LOG_OFF:
      return defaultState;
    default:
      return state;
  }
}
